import React from 'react';
import PropTypes from 'prop-types';
import InputFile from 'realize/components/input/input_file';

import DocumentMetadataFieldsInputGroup from '../form/document_metadata_fields_input_group.jsx';
import DocumentStoreItem from '../../models/document_store_item';
import DocumentSubmitDataContainers from '../../constants/document_submit_data_containers';

import { DocumentActions } from '../../reflux/document_store';

export default class ImportDocumentModal extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		name: PropTypes.string,
		title: PropTypes.string,
		className: PropTypes.string,
		store: PropTypes.object
	};

	static defaultProps = {
		id: '',
		name: '',
		title: 'template.titles.import',
		className: 'import-document-modal',
		store: new DocumentStoreItem()
	};

	constructor(props) {
		super(props);
		this.importDocument = this.importDocument.bind(this);
		this.selectFile = this.selectFile.bind(this);
	}

	get template() {
		return this.props.store.template;
	}

	get waitingForAction() {
		return this.props.store.waitingForAction;
	}

	get fileData() {
		const { submitData } = this.props.store;
		const importSubmitData = submitData[DocumentSubmitDataContainers.IMPORT];

		return importSubmitData ? importSubmitData.file : {};
	}

	get fileIsSelected() {
		return this.props.store.documentFileSelected;
	}

	componentDidUpdate() {
		setTimeout(() => { this.tabOrder() }, 1000);
	}

	componentDidMount() {
		setTimeout(() => { this.tabOrder() }, 1000);
	}

	tabOrder() {
		$('.inputImportDocumentinput-text').attr('tabindex', -1);
		$('.inputImportDocument').attr('tabindex', -1);

		if ($('.button-import-document').attr('disabled') === undefined) {
			$('.button-import-document').unbind('keydown').keydown(function(e) {
				if (e.shiftKey) {
					if (e.shiftKey && e.keyCode === 9) {
						return true;
					}
				}

				if (e.which === 9) {
					$('#documentModal .modal-header span').focus();
					return false;
				}
			});
		} else {
			$('.button-import-document').unbind('keydown').keydown(function(e) {
				if (e.shiftKey) {
					if (e.shiftKey && e.keyCode === 9) {
						return true;
					}
				}

				if (e.which === 9) {
					$('#documentModal .modal-header span').focus();
					return false;
				}
			});
		}
	}

	importDocument() {
		DocumentActions.importDocument(this.props.id);
	}

	selectFile(event) {
		const fileFieldKey = `${DocumentSubmitDataContainers.IMPORT}.file`;
		const selectedFile = event.target.files[0];

		if (!selectedFile) {
			return;
		}

		const splitSelectedFile = selectedFile.name.split('.');
		const lengthSplit = splitSelectedFile.length -1;
		const typeFile = splitSelectedFile[lengthSplit];

		const allowedFileTypes = this.props.store.template.allowedFileTypes;
		const maxFileSizeAllowed = this.props.store.template.maxFileSizeAllowed;

		const validateType = allowedFileTypes.length > 0 ? allowedFileTypes.includes(typeFile) : null;
		const sizeFile = selectedFile.size / 1024;
		const validateSize = sizeFile > maxFileSizeAllowed;

		if (validateType === false && maxFileSizeAllowed === null) {
			DocumentActions.displayFlashMessage(this.props.id, { type: 'error', message: Realize.i18n.t(`template.messages.allowedFileTypes`).replace('@@type@@', allowedFileTypes) });
		} else if (validateType === false && maxFileSizeAllowed !== null && validateSize === true) {
			DocumentActions.displayFlashMessage(this.props.id, { type: 'error', message: Realize.i18n.t(`template.messages.allowedFileTypesSize`).replace('@@type@@', allowedFileTypes).replace('##size##', maxFileSizeAllowed) });
		} else if ((validateType === null || validateType === true) && maxFileSizeAllowed !== null && validateSize === true) {
			DocumentActions.displayFlashMessage(this.props.id, { type: 'error', message: Realize.i18n.t(`template.messages.maxFileSizeAllowed`).replace('##size##', maxFileSizeAllowed) });
		} else {
			DocumentActions.dismissFlashMessage(this.props.id);
		}

		DocumentActions.setSubmitDataField(this.props.id, fileFieldKey, selectedFile);
		DocumentActions.setDocumentFileSelected(this.props.id, selectedFile);
		return false;
	}

	acceptTypeFile() {
		const allowedFileTypes = this.props.store.template.allowedFileTypes;
		const joinFileTypes = allowedFileTypes.join(', .');

		if (joinFileTypes !== "") {
			return `.${joinFileTypes}`;
		}
	}

	renderImportFileInput() {
		return (
			<InputFile
				ref="importFileInput"
				className="inputImportDocument"
				label={Realize.i18n.t('template.attributes.fileName')}
				onChange={this.selectFile}
				fileData={this.fileData}
				readOnly={this.props.readOnly}
				inputReadOnly={true}
				accept={this.acceptTypeFile()}
				onFocus={this.props.onFocus}
			/>
		);
	}

	render() {
		return (
			<div className="modal-import-document">
				<div className="row">
					<div className="col s12">
						{this.renderImportFileInput()}
					</div>
				</div>
				<div className="row">
					<DocumentMetadataFieldsInputGroup {...this.props} containerId={DocumentSubmitDataContainers.IMPORT} />
				</div>
			</div>
		);
	}
}
